var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowLess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.88 14.7099L12 10.8299L8.11999 14.7099C8.02741 14.8025 7.9175 14.876 7.79653 14.9261C7.67557 14.9762 7.54592 15.002 7.41499 15.002C7.28406 15.002 7.15441 14.9762 7.03345 14.9261C6.91248 14.876 6.80257 14.8025 6.70999 14.7099C6.61741 14.6174 6.54397 14.5074 6.49386 14.3865C6.44376 14.2655 6.41797 14.1359 6.41797 14.0049C6.41797 13.874 6.44376 13.7444 6.49386 13.6234C6.54397 13.5024 6.61741 13.3925 6.70999 13.2999L11.3 8.70993C11.69 8.31993 12.32 8.31993 12.71 8.70993L17.3 13.2999C17.3927 13.3924 17.4662 13.5023 17.5164 13.6233C17.5666 13.7443 17.5924 13.874 17.5924 14.0049C17.5924 14.1359 17.5666 14.2656 17.5164 14.3866C17.4662 14.5075 17.3927 14.6174 17.3 14.7099C16.91 15.0899 16.27 15.0999 15.88 14.7099Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowLess);
export default __webpack_public_path__ + "static/media/show-less.16ae639cd0a179315972c8d24fcec4aa.svg";
export { ForwardRef as ReactComponent };